// extracted by css-extract-rspack-plugin
export default {"container":"container--rk_5DPeKHCov9nci"};